module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/barometer-8b6e33cb1de88118509b26e7a8860a5d.svg";